export default "__VITE_ASSET__DySyg_ix__"